<script lang="ts" setup>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const progress = ref(0)

const initAni = () => {
  const gTimeLine = gsap.timeline();
  gTimeLine.fromTo(
    '.milestone__right__lists',
    {
      x: '0%',
      ease: 'none',
      duration: 50000
    },
    {
      x: '-100%',
      duration: 3000,
      scrollTrigger: {
        trigger: '.milestone',
        start: 'top top',
        end: 'bottom',
        scrub: true,
        pin: true,
        onUpdate: data => {
          progress.value = Math.floor(data.progress * 100);
        }
      }
    }
  );
};
defineExpose({
  initAni
});
// onMounted(() => {
//   // initAni()
//   nextTick(() => {
//     useImagesLoaded('.milestone img').then(initAni)
//   });
// })

const handleSkip = () => {
  let top = document.querySelector('#sectionBrands').getBoundingClientRect().top + window.scrollY;
  window.scroll({
    top: top,
    left: 0,
    behavior: 'smooth'
  });
};

const infoLists = ref([
  {
    title: '陳德富會長',
    text: '創立',
    count: 1960
  },
  {
    title: '至今',
    text: '年',
    count: 66
  },
  {
    title: '代理',
    text: '個品牌',
    count: 27
  }
]);

const lists = ref([
  {
    image: './images/story/milestone/2026.jpg',
    type: 'small',
    year: '2026',
    title: 'ReFa、MOVA',
    text: '開啟日本頂級美髮體驗，拓展智慧生活應用場景'
  },
  {
    image: './images/story/milestone/2025.jpg',
    type: 'small',
    year: '2025',
    title: 'WMF',
    text: '德國頂級廚具品牌，締造極致料理體驗'
  },
  {
    image: './images/story/milestone/2024-耳溫槍.jpg',
    type: 'small',
    year: '2024',
    title: 'Joseph Joseph、Braun 耳溫槍',
    text: '打造英式餐廚樂趣，貼近健康護理生活'
  },
  {
    image: './images/story/milestone/2024-crash_baggage.jpg',
    type: 'small',
    year: '2024',
    title: 'Crash Baggage',
    text: '義式旅行風格，拓展風格生活領域'
  },
  {
    image: './images/story/milestone/2023-sakura.jpg',
    type: 'small',
    year: '2023',
    title: 'Sakura Works',
    text: '日系外型設計，讓酒櫃完美融入居家 '
  },
  {
    image: './images/story/milestone/2023.jpg',
    type: 'small',
    year: '2023',
    title: 'SmartCara',
    text: '落實永續精神的廚電設備'
  },
  {
    image: './images/story/milestone/2022.jpg',
    type: 'small',
    year: '2022',
    title: 'Lexon',
    text: '帶進生活風格類的設計品牌'
  },
  {
    image: './images/story/milestone/2021.jpg',
    type: 'large',
    year: '2021',
    title: '成立概念店zonezone',
    text: ''
  },
  {
    image: './images/story/milestone/2020.jpg',
    type: 'large',
    year: '2020',
    title: '啟動前中後台數位轉型專案',
    text: ''
  },
  {
    image: './images/story/milestone/2019-line.jpg',
    type: 'large',
    year: '2019',
    title: '以 Line 官方增營線上客服管道',
    text: ''
  },
  {
    image: './images/story/milestone/2019-vermicular.jpg',
    type: 'small',
    year: '2019',
    title: 'Style、Medisana、Vermicualr、Dafni、Laurastar、Braun廚電',
    text: '觸角延伸至更多生活日用品牌'
  },
  {
    image: './images/story/milestone/2017.jpg',
    type: 'small',
    year: '2017',
    title: 'magimix、Stasher、Oxo',
    text: '觸角延伸至更多生活日用品牌'
  },
  {
    image: './images/story/milestone/2016.jpg',
    type: 'small',
    year: '2016',
    title: 'CORKCICLE、Sunbeam',
    text: '觸角延伸至更多生活日用品牌'
  },
  {
    image: './images/story/milestone/2014.jpg',
    type: 'large',
    year: '2014',
    title: '電話客服、維修、物流系統數位化 ',
    text: ''
  },
  {
    image: './images/story/milestone/2013.jpg',
    type: 'small',
    year: '2013',
    title: 'Coway、Foodsaver、Oster、Braun、Oral-B',
    text: '擴大健康、個人護理領域'
  },
  {
    image: './images/story/milestone/2011.jpg',
    type: 'large',
    year: '2011',
    title: '企業官網與購物網站上線 ',
    text: ''
  },
  {
    image: './images/story/milestone/2010.jpg',
    type: 'small',
    year: '2010',
    title: 'Honeywell',
    text: '第一個導入的空氣清淨機品牌'
  },
  {
    image: './images/story/milestone/2009.jpg',
    type: 'small',
    year: '2009',
    title: 'Sodastream',
    text: '率先引進尚未流行的氣泡飲機'
  },
  {
    image: './images/story/milestone/2008.jpg',
    type: 'large',
    year: '2008',
    title: '成立到府服務團隊，協助消費者在家瞭解商品與現場維修',
    text: ''
  },
  {
    image: './images/story/milestone/2006.jpg',
    type: 'small',
    year: '2006',
    title: 'dyson',
    text: '首次獨家代理的歐洲品牌'
  },
  {
    image: './images/story/milestone/2005.jpg',
    type: 'small',
    year: '2005',
    title: 'Twinbird',
    text: '進軍生活家電領域'
  },
  {
    image: './images/story/milestone/2002.jpg',
    type: 'large',
    year: '2002',
    title: '併購忠臣家電（loyola）取得百貨專櫃經營權。',
    text: '正式建立自有通路'
  },
  {
    image: './images/story/milestone/1967.jpg',
    type: 'small',
    year: '1967',
    title: 'panasonic電池',
    text: '第一個代理的日本品牌'
  }
]);
</script>

<template>
  <section class="milestone">
    <div class="milestone__inner">
      <div class="milestone__left">
        <div class="milestone__title">milestone</div>
        <ul class="milestone__info">
          <li v-for="(item, index) in infoLists" :key="index">
            <div class="milestone__info__title">{{ item.title }}</div>
            <div class="milestone__info__bottom">
              <div class="milestone__info__count">{{ item.count }}</div>
              <div class="milestone__info__text">{{ item.text }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="milestone__right">
        <ul class="milestone__right__lists">
          <li v-for="(item, index) in lists" :key="index">
            <div class="milestone__right__lists__item">
              <figure class="milestone__right__lists__pic" :class="item.type">
                <Nimg :src="item.image"></Nimg>
              </figure>
              <div class="milestone__right__lists__bottom" :class="item.type">
                <div class="milestone__right__lists__year">{{ item.year }}</div>
                <div class="milestone__right__lists__title">{{ item.title }}</div>
                <div class="milestone__right__lists__text" v-if="item.text">{{ item.text }}</div>
              </div>
            </div>
          </li>
        </ul>
        <div class="milestone__right__skip pc" @click="handleSkip">skip</div>
      </div>
      <div class="milestone__bottom">
        <div class="milestone__right__skip mobile" @click="handleSkip">skip</div>
        <div class="milestone__progress mobile">
          <div class="milestone__progress__item">
            <div class="milestone__progress__bar">
              <div class="milestone__progress__bar__item" :style="{ width: progress + '%' }"></div>
            </div>
            <div class="milestone__progress__text start">2023</div>
            <div class="milestone__progress__text end">1967</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.milestone {
  position: relative;
  padding-top: toRem(140);
  padding-bottom: toRem(130);

  &::after {
    content: '';
    position: absolute;
    left: toRem(-24);
    top: 0;
    z-index: -1;
    width: calc(100% + toRem(48));
    height: 100%;
    background-color: $color-black-1;
  }

  &__inner {
    padding-left: toRem(24);
    padding-right: toRem(24);
    @include grid;

    @include max-media(640) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__progress {
    width: 100%;
    margin-top: auto;
    max-width: toRem(354);

    @include max-media(640) {
      max-width: 100%;
    }

    &.pc {
      @include max-media(640) {
        display: none;
      }
    }

    &__item {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &__bar {
      width: 100%;
      border-top: 1px solid $color-gray-1;
      margin-bottom: toRem(12);

      &__item {
        height: toRem(7);
        background-color: $color-brand-3;
      }
    }

    &__text {
      font-size: toRem(14);
      font-weight: 500;
      font-family: $font-TextaAlt;
      line-height: 0.8;
      color: $color-gray-1;

      &.start {
        color: $color-brand-3;
      }
    }
  }

  &__title {
    font-family: $font-TextaAlt;
    font-size: toRem(158);
    font-weight: 500;
    line-height: 0.8;
    color: $color-gray-1;
    opacity: 0.5;
    margin-bottom: toRem(45);

    @include max-media(1280) {
      font-size: toRem(80);
    }
  }

  &__left {
    display: flex;
    flex-direction: column;
    grid-column: 2 / span 5;

    @include max-media(1280) {
      grid-column: 1 / span 5;
    }
  }

  &__bottom {
    grid-column: 1 / span 12;

    @include min-media(641) {
      display: none;
    }
  }

  &__info {
    display: flex;
    color: $color-white-1;

    @include max-media(1280) {
      flex-direction: column;
    }

    li {
      &:not(:last-child) {
        margin-right: toRem(56);

        @include max-media(1280) {
          margin-right: 0;
          margin-bottom: toRem(40);
        }
      }
    }

    &__title {
      @include max-media(640) {
        margin-bottom: toRem(10);
      }
    }

    &__title,
    &__text {
      font-size: toRem(16);
      line-height: 1.45;
    }

    &__bottom {
      display: flex;
      align-items: right;
    }

    &__count {
      font-size: toRem(80);
      font-family: $font-TextaAlt;
      font-weight: 500;
      line-height: 0.8;

      @include max-media(640) {
        font-size: toRem(32);
        margin-right: toRem(10);
      }
    }
  }

  &__right {
    grid-column: 8 / span 5;
    overflow: hidden;
    margin-right: toRem(-72);

    @include max-media(640) {
      grid-column: 6 / span 7;
      margin-top: toRem(80);
    }

    &__lists {
      display: flex;
      width: max-content;
      margin-bottom: toRem(70);

      li {
        flex-shrink: 0;

        &:not(:last-child) {
          margin-right: toRem(120);
        }
      }

      &__item {
        width: toRem(383);

        @include max-media(640) {
          width: toRem(220);
        }
      }

      &__pic {
        display: flex;
        justify-content: flex-end;
        width: 100%;

        &.large {
          img {
            width: 100%;
          }
        }

        &.small {
          margin-top: toRem(50);

          img {
            width: toRem(289);

            @include max-media(640) {
              width: 100%;
            }
          }
        }

        img {
          display: block;
          max-width: 100%;
        }
      }

      &__bottom {
        &.small {
          margin-top: toRem(-25);

          @include max-media(640) {
            margin-top: toRem(-15);
          }
        }

        &.large {
          margin-top: toRem(-40);

          @include max-media(640) {
            margin-top: toRem(-15);
          }
        }
      }

      &__year {
        margin-bottom: toRem(12);
        font-size: toRem(80);
        font-family: $font-TextaAlt;
        font-weight: 500;
        line-height: 0.8;
        color: $color-gray-2;

        @include max-media(640) {
          font-size: toRem(42);
        }
      }

      &__title {
        margin-bottom: toRem(12);
        font-size: toRem(20);
        font-weight: 500;
        line-height: 1.4;
        color: $color-white-1;

        @include max-media(640) {
          font-size: toRem(16);
        }
      }

      &__text {
        font-size: toRem(16);
        font-weight: 400;
        line-height: 1.45;
        color: $color-white-1;
      }
    }

    &__skip {
      width: 100%;
      padding-right: toRem(120);
      text-align: right;
      color: $color-gray-2;
      font-family: $font-TextaAlt;
      font-size: toRem(32);
      padding-bottom: toRem(10);
      font-weight: 500;
      line-height: 0.8;
      cursor: pointer;

      @include max-media(640) {
        padding-right: 0;
        margin-bottom: toRem(24);
        font-size: toRem(16);
        color: $color-brand-3;
      }

      &.pc {
        @include max-media(640) {
          display: none;
        }
      }
    }
  }
}
</style>
